export default ({
  is_staff = false,
  is_superuser = false,
  is_maintenance = false,
} = {}) => ({is_staff, is_superuser, is_maintenance});
